// Recovered compiled webpack factory 97309. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Gv: () => l, P4: () => i, sY: () => s, ti: () => u });
  var n = r(43275),
    a = r(96812);
  let o = Symbol.for("sentry__originalRequestBody");
  function i(e) {
    return new URLSearchParams(e).toString();
  }
  function s(e, t = n.Yz) {
    try {
      if ("string" == typeof e) return [e];
      if (e instanceof URLSearchParams) return [e.toString()];
      if (e instanceof FormData) return [i(e)];
      if (!e) return [void 0];
    } catch (r) {
      return (a.T && t.error(r, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"]);
    }
    return (
      a.T && t.log("Skipping network body because of body type", e),
      [void 0, "UNPARSEABLE_BODY_TYPE"]
    );
  }
  function l(e = []) {
    if (e.length >= 2 && e[1] && "object" == typeof e[1] && "body" in e[1]) return e[1].body;
    if (e.length >= 1 && e[0] instanceof Request) {
      let t = e[0][o];
      if (void 0 !== t) return t;
    }
  }
  function u(e) {
    let t;
    try {
      t = e.getAllResponseHeaders();
    } catch (t) {
      return (a.T && n.Yz.error(t, "Failed to get xhr response headers", e), {});
    }
    return t
      ? t.split("\r\n").reduce((e, t) => {
          let [r, n] = t.split(": ");
          return (n && (e[r.toLowerCase()] = n), e);
        }, {})
      : {};
  }
}
